var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrnMapHelpAreasOfFocusSubcategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "25px",
    viewBox: "0 0 29 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BRN---Mapping-the-Network---Instructions",
    transform: "translate(-494.000000, -599.000000)",
    fill: "#FFFFFF",
    stroke: "#0177CB",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(496.000000, 601.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9286368,0.287639024 C19.0315577,-1.44170121 26.683934,4.82292768 24.6757022,13.8090924 C23.0686758,21 13.4559529,22.7181615 6.58232372,19.3202927 C-4.31074743,13.9354769 -0.867413965,2.8051738 10.9286368,0.287639024 Z",
    id: "Path-3-Copy-2",
    transform: "translate(12.500000, 10.500000) scale(-1, 1) translate(-12.500000, -10.500000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrnMapHelpAreasOfFocusSubcategory);
export default __webpack_public_path__ + "static/media/BRN-Map-Help-AreasOfFocus-Subcategory.c18efc2d69a19b422b5ab684fec721b7.svg";
export { ForwardRef as ReactComponent };